export class GetRolesEnum {
    public static readonly type = '[Roles enum] get';
}

export class GetGendersEnum {
    public static readonly type = '[Genders enum] get';
}

export class GetEducationLevelsEnum {
    public static readonly type = '[Education Levels enum] get';
}

export class GetEducationTypesEnum {
    public static readonly type = '[Education Types enum] get';
}

export class GetCostsRepartitionEnum {
    public static readonly type = '[Costs Repartition enum] get';
}

export class GetClassTypesEnum {
    public static readonly type = '[Class Types enum] get';
}

export class GetRateTypesEnum {
    public static readonly type = '[Rate Types enum] get';
}

export class GetCustodyTypesEnum {
    public static readonly type = '[Custody Types enum] get';
}

export class GetRelativeTypesEnum {
    public static readonly type = '[Relative Types enum] get';
}

export class GetContactTypesEnum {
    public static readonly type = '[Contact Types enum] get';
}

export class GetCreditTypesEnum {
    public static readonly type = '[Credit Types enum] get';
}

export class GetDebitTypesEnum {
    public static readonly type = '[Debit Types Enum] get';
}

export class GetStorageTypesEnum {
    public static readonly type = '[Storage types enum] get';
}

export class SetInit {
    public static readonly type = '[Enums] set init';
}
